/**
 * TipTap's getHTML() serializes empty paragraphs as `<p></p>`. Browsers give
 * those zero height, so blank lines disappear in read-only HTML and after save.
 * Use a non-breaking space so vertical gaps match the editor and round-trips.
 */
export function normalizeRichEditorHtmlForStorage(html: string): string {
  return html.replace(/<p>\s*<\/p>/gi, '<p>&nbsp;</p>')
}
